export enum YesNoOption {
  Yes = 1,
  No = 2,
}
